export const selectAdminFeatureState = rootState => rootState.features.admin;



// WEBPACK FOOTER //
// ./src/store/features/admin/selectors.js